import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const before = ['Te sientes inconsistente y frustrada', 'No entiendes por qué cambias tanto', 'Te exiges igual todos los días', 'Sientes que algo está mal contigo'];
const after = ['Te entiendes y te respetas', 'Tomas mejores decisiones cada semana', 'Te sientes en control de tu energía', 'Dejas de exigirte incorrectamente'];
export function TransformationSection() {
  return <section className="w-full bg-bg-main py-16 md:py-24 px-4" data-id="element-114">
      <div className="max-w-6xl mx-auto" data-id="element-115">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-12" data-id="element-116">
          Imagina la diferencia
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white/50 rounded-2xl p-8 space-y-6" data-id="element-118">
            <h3 className="font-serif text-2xl text-text-secondary text-center mb-6" data-id="element-119">
              Antes
            </h3>
            <div className="space-y-4" data-id="element-120">
              {before.map((item, index) => <div key={index} className="flex gap-3 items-start" data-id="element-121">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mt-1" data-id="element-122">
                    <X className="w-4 h-4 text-gray-600" strokeWidth={2.5} data-id="element-123" />
                  </div>
                  <p className="text-text-secondary" data-id="element-124">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-primary/10 rounded-2xl p-8 space-y-6 border-2 border-primary/20" data-id="element-125">
            <h3 className="font-serif text-2xl text-accent text-center mb-6" data-id="element-126">
              Después
            </h3>
            <div className="space-y-4" data-id="element-127">
              {after.map((item, index) => <div key={index} className="flex gap-3 items-start" data-id="element-128">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center mt-1" data-id="element-129">
                    <Check className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-130" />
                  </div>
                  <p className="text-text-primary font-medium" data-id="element-131">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}